interface ConsultationEnCoursModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  patientEnCours: string;
  nouveauPatient: string;
}

export default function ConsultationEnCoursModal({
  isOpen,
  onClose,
  onConfirm,
  patientEnCours,
  nouveauPatient
}: ConsultationEnCoursModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-4 sm:p-6">
          <div className="w-14 h-14 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-alert-line text-2xl sm:text-3xl text-amber-600"></i>
          </div>

          <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-3">
            Consultation en cours
          </h2>

          <p className="text-center text-gray-600 mb-2 text-sm sm:text-base px-2">
            Vous avez déjà une consultation en cours avec
          </p>
          <p className="text-center text-gray-900 font-bold text-lg mb-4">
            {patientEnCours}
          </p>
          <p className="text-center text-gray-500 mb-6 text-xs sm:text-sm px-2">
            Si vous démarrez une nouvelle consultation avec <strong>{nouveauPatient}</strong>, la consultation en cours avec <strong>{patientEnCours}</strong> sera automatiquement fermée.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 sm:px-6 py-2 sm:py-3 border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors font-semibold whitespace-nowrap cursor-pointer text-sm"
            >
              Retour
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 sm:px-6 py-2 sm:py-3 bg-amber-600 text-white rounded-xl hover:bg-amber-700 transition-colors font-semibold whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-arrow-right-line mr-2"></i>
              Continuer quand même
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}